import { Editor } from '@tiptap/vue-2';
import StarterKit from '@tiptap/starter-kit';
import { RedMark } from './RedMarkExtension';

export const convertRedTagsToHTML = (content) => {
    if (!content) return '<p></p>';
    
    let html = '<p>';
    let parts = content.split(/(\[RED\].*?\[\/RED\])/);
    
    parts.forEach(part => {
        if (part.startsWith('[RED]') && part.endsWith('[/RED]')) {
            const text = part.substring(5, part.length - 6);
            html += '<span data-red-mark="true" style="border: solid red 2px; padding: 2px; display: inline;">' + escapeHtml(text) + '</span>';
        } else if (part) {
            const escaped = escapeHtml(part);
            html += escaped.replace(/\n/g, '<br>');
        }
    });
    
    html += '</p>';
    return html;
};

export const convertHTMLToRedTags = (html) => {
    if (!html || html === '<p></p>') return '';
    
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    
    const processNode = (node) => {
        if (node.nodeType === Node.TEXT_NODE) {
            return node.textContent || '';
        }
        
        if (node.nodeType === Node.ELEMENT_NODE) {
            const tagName = node.tagName.toLowerCase();
            
            if (tagName === 'span') {
                if (node.getAttribute('data-red-mark') === 'true') {
                    const content = Array.from(node.childNodes).map(processNode).join('');
                    return '[RED]' + content + '[/RED]';
                }
                const styleText = node.style ? (node.style.cssText || node.getAttribute('style') || '') : '';
                if (styleText.includes('border: solid red 2px') || 
                    styleText.includes('border:solid red 2px') ||
                    styleText.includes('border:  solid red 2px')) {
                    const content = Array.from(node.childNodes).map(processNode).join('');
                    return '[RED]' + content + '[/RED]';
                }
            }
            
            const content = Array.from(node.childNodes).map(processNode).join('');
            
            if (['p', 'div', 'br'].includes(tagName)) {
                return content + (tagName === 'br' ? '\n' : '\n');
            }
            
            return content;
        }
        
        return '';
    };
    
    let result = Array.from(tempDiv.childNodes).map(processNode).join('');
    result = result.replace(/\n\n+/g, '\n').trim();
    return result;
};

export const escapeHtml = (text) => {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
};

export const createRedMarkEditor = (content, onUpdate) => {
    return new Editor({
        extensions: [
            StarterKit.configure({
                paragraph: {
                    HTMLAttributes: {
                        class: 'mb-2',
                    },
                },
            }),
            RedMark,
        ],
        content: convertRedTagsToHTML(content || ''),
        editorProps: {
            attributes: {
                class: 'prose prose-sm max-w-none focus:outline-none',
            },
        },
        onUpdate: ({ editor }) => {
            const html = editor.getHTML();
            const redTagContent = convertHTMLToRedTags(html);
            if (onUpdate) onUpdate(redTagContent);
        },
    });
};

export const ALL_EDITOR_NAMES = [
    'textEditor', 'alertEditor', 'headerTitleEditor', 'headerSubtitleEditor',
    'textTitleEditor', 'footerCompanyNameEditor', 'footerAddressEditor',
    'footerPhoneEditor', 'footerEmailEditor'
];

export const destroyAllEditors = (component) => {
    ALL_EDITOR_NAMES.forEach(editorName => {
        if (component[editorName]) {
            component[editorName].destroy();
            component[editorName] = null;
        }
    });
};

export const processRedMarkersForPreview = (text) => {
    if (!text) return '';
    return text.replace(/\[RED\](.*?)\[\/RED\]/g, '<span style="border: solid red 2px; padding: 2px; display: inline;">$1</span>');
};

